/**
 * @file Hero — page header for the weekly challenge. Presentational only.
 */

const DEFAULT_DESCRIPTION =
  'Every week a brand-new AI-generated racing challenge is created with a ' +
  'unique skybox, track and soundtrack.';

/**
 * @param {{
 *   title?: string,
 *   subtitle?: string,
 *   description?: string
 * }} props
 */
export function Hero({
  title = 'Sky City Rush',
  subtitle = 'Weekly Challenge',
  description = DEFAULT_DESCRIPTION,
}) {
  return (
    <header className="scrw-challenge__hero">
      <p className="scrw-challenge__eyebrow">{subtitle}</p>
      <h1 className="scrw-challenge__title">{title}</h1>
      <p className="scrw-challenge__lede">{description}</p>
    </header>
  );
}
